module.exports = {
      id: "close-usage",
      viewBox: "0 0 512.001 512.001",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#close",
      toString: function () {
        return this.url;
      }
    }